import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CartItemType, PublicProjectCartItem } from "../../../../../../../api/src/cart/project-cart-item.entity";
import { TaskStatus } from "../../../../../../../api/src/encode/encode-task.entity";
import { CartItem, CartItemGroup } from "../../../../_core/state/cart/cart.model";
import { getExportTypeTranslations } from "../../../../_core/services/localization.service";
import { CartService } from "../../../../_core/state/cart/cart.service";
import { ExportDownloadUtils } from "../export-download.utils";
import { CartUtils } from '../../../../_core/state/cart/cart.utils';
import { ExportType } from "../../../../../../../api/src/encode/models/job-def.dto";

export interface DownloadItemEvent {
	cartItem?: PublicProjectCartItem;
	format?: ExportType;
}

@Component({
	selector: 'app-export-download-group-row',
	templateUrl: './export-download-group-row.component.html',
	styleUrl: './export-download-group-row.component.scss'
})
export class ExportDownloadGroupRowComponent implements OnChanges {
	protected readonly CartUtils = CartUtils;
	protected readonly CartItemType = CartItemType;
	protected readonly TaskStatus = TaskStatus;
	protected readonly ExportDownloadUtils = ExportDownloadUtils;
	readonly EXPORT_TYPE_LABELS  = getExportTypeTranslations();

	@Input() group: any;

	@Output() downloadItem: EventEmitter<DownloadItemEvent> = new EventEmitter<DownloadItemEvent>();
	@Output() downloadByGroupId: EventEmitter<CartItem> = new EventEmitter<CartItem>();
	@Output() downloadByPackageId: EventEmitter<CartItem> = new EventEmitter<CartItem>();
	@Output() retryJobId: EventEmitter<string> = new EventEmitter<string>();
	@Output() retryTasks: EventEmitter<void> = new EventEmitter<void>();

	public combinedGroups: CartItemGroup[] = [];

	constructor(
		public readonly projectCartService: CartService
	) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.group && changes.group.currentValue) {
			this.combinedGroups = this.projectCartService
				.combineItemsWithSubgroupItems(this.group)
				.sort((a, b) => a.name.localeCompare(b.name));
		}
	}

}
